<template>
    <div>
        <v-card flat>
            <v-toolbar color="#303a55" dark extended flat>
            </v-toolbar>
            <v-card class="mx-auto pa-4" max-width="700" style="margin-top: -64px;">
                <v-img :src="require('./../assets/VULlogo.png')" width="100" height="100" class="mx-auto">
                </v-img>
                <v-card-title class="justify-center">Welcome to VUL</v-card-title>
                <v-card-subtitle class="text-center">FEE PAYMENT GATEWAY</v-card-subtitle>
                <v-card-text>
                    <v-container>
                        <v-form v-model="valid" ref="form">
                            <v-text-field label="First Name" outlined color="#303a55" dense v-model="firstname" :rules="firstnameRules">
                            </v-text-field>
                            <v-text-field label="Last Name" outlined color="#303a55" dense v-model="lastname" :rules="lastnameRules">
                            </v-text-field>
                            <v-text-field label="Email Id" outlined color="#303a55" dense v-model="emailid" :rules="emailRules">
                            </v-text-field>
                            <label for="">Choose Payment Plan</label>
                            <v-radio-group v-model="row" column :rules="paymentOptionRules" class="mb-2" @change="updateAmount">
                                <v-radio :label="`$1750 per month`" value="monthly"></v-radio>
                                <v-radio :label="`$7000 per semester (lump-sum)`" 
                                value="semester"></v-radio>
                            </v-radio-group>

                            <v-text-field label="Amount" disabled outlined dense color="#303a55" v-model="amount">
                            </v-text-field>

                            <v-text-field label="Card Number" :rules="cardNoRules" oninput="this.value=this.value.replace(/[^\d]/,'')" outlined color="#303a55" dense type="tel" class="mt-4" v-model="cardNumber">
                            </v-text-field>

                            <v-text-field label="Name on Card" outlined dense color="#303a55" v-model="cardName" :rules="cardNameRules">
                            </v-text-field>

                            <v-row>
                                <v-col cols="6" class="pt-0 pb-0">
                                    <label for="">Expires</label>
                                    <v-row>
                                        <v-col cols="6" class="pt-0 pb-0 pr-1">
                                            <v-text-field placeholder="MM" outlined color="#303a55" dense v-model="expireMonth" :rules="monthRules"></v-text-field>
                                        </v-col>
                                        <v-col cols="6" class="pt-0 pb-0 pl-0">
                                            <v-text-field placeholder="YYYY" outlined color="#303a55" dense v-model="expireYear" :rules="yearRules"></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="6" class="pt-0 pb-0 mt-5">
                                    <v-text-field label="CVV" :rules="cvvRules" outlined color="#303a55" dense type="tel" v-model="cardCvv">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-text-field label="Address Line" dense outlined color="#303a55" v-model="address" :rules="addressRules">
                            </v-text-field>

                            <v-text-field label="City" dense outlined color="#303a55" v-model="city" :rules="cityRules">
                            </v-text-field>
                            <v-row>
                                <v-col cols="6" class="pt-0 pb-0">
                                    <v-text-field label="State" dense outlined color="#303a55" v-model="state" :rules="stateRules"></v-text-field>
                                </v-col>
                                <v-col cols="6" class="pt-0 pb-0">
                                    <v-text-field label="ZIP Code" dense outlined color="#303a55" v-model="zipcode" :rules="zipcodeRules"></v-text-field>
                                </v-col>
                            </v-row>

                            <v-text-field label="Comments" v-model="comments" outlined dense color="#303a55"></v-text-field>
                            
                            <v-checkbox v-model="disclaimer" :rules="disclaimerRules" label="I confirm that the information for the credit card and billing address is complete and accurate"></v-checkbox>
                            <v-checkbox v-model="recurring" label=" I hereby Authorize to charge my credit card with the above mentioned amount on recurring basis"></v-checkbox>

                            <v-btn color="#303a55" dark @click="register" block class="mt-5" :loading="loading">
                                Submit
                            </v-btn>
                        </v-form>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-card>
        <snackbar :snackbar.sync="modal" :message.sync="message" :snackbarcolor.sync="color" v-on:closeSnackbar="closeSnackbar"></snackbar>
    </div>
</template>
<script>    
    import {UserService} from './../services/UserService.js';
    import Snackbar from './Snackbar.vue';
    export default {
        data(){
            return{
                firstname: '',
                lastname: '',
                emailid: '',
                ssn: '',
                cardName: '',
                cardNumber: '',
                cardCvv: '',
                address: '',
                city: '',
                state: '',
                zipcode: '',
                amount: '',
                disclaimer: false,
                recurring: false,
                row: '',
                comments: '',
                expireMonth: '',
                expireYear: '',
                paymentOptionRules: [
                    v => !!v || 'Please choose a payment option'
                ],
                firstnameRules: [
                    v => !!v || 'Firstname is required'
                ],
                lastnameRules: [
                    v => !!v || 'Lastname is required'
                ],
                ssnRules: [
                    v => !!v || 'SSN is required',
                    v => (v && v.length == 4) || 'four digits are required'
                ],
                cardNoRules: [
                    v => !!v || 'Card Number is required'
                ],
                cardNameRules: [
                    v => !!v || 'Card holder name is required'
                ],
                cvvRules: [
                    v => !!v || 'CVV is required'
                ],
                addressRules: [
                    v => !!v || 'Address line is required'
                ],
                cityRules: [
                    v => !!v || 'City is required'
                ],
                stateRules: [
                    v => !!v || 'State is required',
                ],  
                zipcodeRules: [
                    v => !!v || 'Zip Code is required'
                ],
                amountRules: [
                    v => !!v || 'Amount is required'
                ],
                disclaimerRules: [
                    v => !!v || 'This is required'
                ],
                monthRules: [
                    v => !!v || '*Required',
                    v => (v && v.length == 2) || 'must be valid'
                ],
                yearRules: [
                    v => !!v || '*Required',
                    v => (v && v.length == 4) || 'must be valid'
                ],
                emailRules: [
                    v => !!v || '*Required',
                    v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
                ],
                valid: false,
                modal: false,
                message: '',
                loading: false,
                color: 'red accent-3'
            }
        },
        components: {
            Snackbar
        },
        methods: {
            closeSnackbar(value){
                this.modal=value;
            },
            updateAmount(){
                this.amount = (this.row == 'monthly' ? '1750' : '7000');
            },
            register(){
                let data = {
                    firstname: this.firstname,
                    lastname: this.lastname,
                    amount: this.amount,
                    cardnumber: this.cardNumber,
                    cardname: this.cardName,
                    expires: this.expireMonth+'/'+this.expireYear,
                    cvv: this.cardCvv,
                    address: this.address,
                    city: this.city,
                    state: this.state,
                    zipcode: this.zipcode,
                    disclaimer: this.disclaimer,
                    recurring: this.recurring,
                    paymentOption: this.row,
                    comments: this.comments,
                    emailid: this.emailid,
                    subject: this.$route.params.semester == 'spring' ? 'SPRING 2027 COHORT TUITION PAYMENT' : 'FALL 2026 COHORT TUITION PAYMENT'
                };
                if(this.$refs.form.validate()){
                    this.loading = true;
                    UserService.register(data).then((response) => {
                        this.modal = true;
                        this.color = "success";
                        this.message = "Thank you! Your payment information has been successfully submitted.";
                        this.$refs.form.reset();
                        this.loading = false;
                        console.log('response', response.data.message);
                    }).catch((error) => {
                        this.modal = true;
                        this.color = "red accent-3";
                        this.message = error.response.data.message;
                        this.loading = false;
                    })
                }
                else{
                    this.modal = true;
                    this.color = "red accent-3";
                    this.message = "Please fill in the details to continue";   
                }
            }
        },
        mounted(){
            localStorage.clear();
        }
    }
</script>

<style scoped>
    .bg-cream{
        background-color: white;
    }
</style>